import actions from './actions'
import mutations from './mutations'
import getters from './getters'

import ages from './ages/index'
import sports from './sports/index'
import countries from './countries/index'
import genders from './genders/index'
import partners from './partners/index'
import roles from './roles/index'
import tournaments from './tournaments/index'
import teams from './teams/index'
import matches from './matches/index'
import events from './events/index'
import tournamentCountry from './tournamentCountry/index'

export default API => ({
  state: {
    // sports: {
    //   data: [],
    //   recordsFiltered: null
    // },
    // countries: {
    //   data: [],
    //   recordsFiltered: null
    // },
    // genders: {
    //   data: [],
    //   recordsFiltered: null
    // },
    // ages: {
    //   data: [],
    //   recordsFiltered: null
    // },
    // partners: {
    //   data: [],
    //   recordsFiltered: null
    // },
    // roles: {
    //   data: [],
    //   recordsFiltered: null
    // },
    reasons: {
      data: [],
      recordsFiltered: null
    },
    abilities: {
      data: [],
      recordsFiltered: null
    },
    watermarks: {
      data: [],
      recordsFiltered: null
    },
    sources: {
      data: [],
      recordsFiltered: null
    },
    restreamersServers: {
      data: [],
      recordsFiltered: null
    },
    bells: {
      data: [],
      recordsFiltered: null
    }
  },
  actions: actions(API),
  mutations,
  getters,
  modules: {
    partners,
    roles,
    ages,
    sports,
    countries,
    genders,
    tournaments,
    teams,
    matches,
    events,
    tournamentCountry
  }
})
